/**
 * Check if the value provided is defined
 * @param value Value to check if it is defined
 * @returns True or false depending if the argument is defined
 */
export const isDefined = <Value>(value?: Value | null): value is NonNullable<Value> =>
	value !== null && value !== undefined;
